// extracted by mini-css-extract-plugin
var _1 = "t2mSPc4jtj";
export { _1 as "screen" }
